module.exports = __webpack_public_path__ + "img/20.580a6598.jpg";